export default {
      id: "sber-usage",
      viewBox: "0 0 57 21",
      url: __webpack_public_path__ + "svgsprite.svg#sber",
      toString: function () {
        return this.url;
      }
    }